import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faFilter, faRecycle, faSearch, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';

//Components
import InfoCard from '../../../components/InfoCard/InfoCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import dashboard_api from '../../../api/dashboard_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useDashboard } from 'context/DashboardContext';
import AutosInfracoes from './AutosInfracoes';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 30);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        prefeituraId: 0,
    }
}
export default function DashBoardDestino() {
    const { dadosDashboardProvider, setDadosDashboardProvider } = useDashboard();
    
    //Estado que guarda os dados da dashboard
    const [dadosDashboard, setDadosDashboard] = useState(null);
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);
    //Estado de controle da visualização dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Estado que controlar a exibição da lista dos autos das infrações
    const [visibleAutosInfracoes, setVisibleAutosInfracoes] = useState(false);

    //Função de troca do estado de visualização dos filtros
    const toggleFiltros = () => {
        setOpenFiltros(!openFiltros);
    };
    //OnChange para os campos de filtros de datas
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }
    //Função que carrega os dados da dashboard
    const carregaDashboard = (buttonFiltro = false) => {
        if(!buttonFiltro && !!dadosDashboardProvider && !!dadosDashboardProvider?.recarregarViaContext){
            setDadosDashboard(dadosDashboardProvider);
            return;
        }  

        setLoading(true);
        const _filtros = { ...filtros };
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        dashboard_api.GetDashboard(_filtros).then(response => {
            setDadosDashboard(response.data);
            setDadosDashboardProvider({...response.data, recarregarViaContext: true});
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Carrega os dados da dashboard assim que inicializada
    useEffect(() => {
        carregaDashboard();
    }, []);

    if(visibleAutosInfracoes){
            return <AutosInfracoes
                btnVoltar={() => { 
                    carregaDashboard(true);
                    setVisibleAutosInfracoes(false);
                }}
            />
    }

    return (
        <div className='mt-4 ms-4'>
            {loading && <Loading />}
            <div className='d-flex align-items-center justify-content-between mx-4'>
                <h4>Dados de coletas</h4>
                <Button color='primary' onClick={toggleFiltros}><FontAwesomeIcon icon={faFilter} /> Filtros</Button>
            </div>
            <div className={`filtros ${!openFiltros ? "close" : ""}`}>
                <Row className=' mx-4'>
                    <Col md="12" lg="5">
                        <TextField label={"Inicio"} type="date" value={filtros.dataInicial} name={"dataInicial"} onChange={onChangeFiltros} />
                    </Col>
                    <Col md="12" lg="5">
                        <TextField label={"Fim"} type="date" value={filtros.dataFinal} name={"dataFinal"} onChange={onChangeFiltros} />
                    </Col>
                </Row>
                <div className="w-100 mx-4">
                    <Button color='info text-light' className='ms-3' onClick={() => carregaDashboard(true)} >
                        <FontAwesomeIcon icon={faSearch} className="me-3" /> Filtrar
                    </Button>
                </div>
            </div>
            <div className='mt-4 mx-4'>
                <Row>
                    <Col md="12" lg="6">
                        <InfoCard icon={faTruck} title={"Coletas Recebidas"} specialSubTitle={dadosDashboard?.coletasRecebidas} />
                    </Col>
                    <Col md="12" lg="6">
                        <InfoCard icon={faRecycle} title={"Volume Recebido"} specialSubTitle={dadosDashboard?.volumeRecebido + "Kg"} />
                    </Col>
                </Row>
            </div>
            <div className='mx-4 mt-4'> 
                <h4>Autos de infração</h4>
                <Row className='mb-4'>
                    <Col md="12" lg="4">
                        <InfoCard 
                            link 
                            icon={faBalanceScale} 
                            onClick={() => {
                                if(dadosDashboard?.quantidadeAutoInfracoes == 0)
                                    return showMessage("Aviso", "Você não tem nenhum auto de infração.", "warning", null);
                                
                                setVisibleAutosInfracoes(true);
                            }} 
                            title={"Quantidade de autos de infração"} 
                            specialSubTitle={dadosDashboard?.quantidadeAutoInfracoes > 0 ? dadosDashboard?.quantidadeAutoInfracoes  : "0"} 
                        />
                    </Col>
                </Row>
            </div>
        </div>
    )
}